import { connect } from 'react-redux';
import Component from './Component';

const mapStateToProps = () => ({
});

export default connect(mapStateToProps)(Component);